// extracted by mini-css-extract-plugin
export default {"containerLoading":"Loading_containerLoading__wSA5-","loader":"Loading_loader__CFnVt","rotate":"Loading_rotate__ULd5y","prixClipFix":"Loading_prixClipFix__SkhV5"};